import {createGlobalStyle} from "styled-components";

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    color: #2F2E41FF;
    font-family: 'Mulish', sans-serif;
  }

  :root {
    --color-white: #FAFAFAFF;
    --color-red: #E9405BFF;
    --color-purple: #4909AA;
    --color-purple-06: #7c51bd;
    --color-purple-lighten: #E8E2F3;
    --color-blue: #3394F6;
    --color-blue-06: #89BDF8;
    --color-blue-03: #3394F64C;
    --color-pale-blue: #eceef5;
    --color-green: #52D783FF;
    --color-green-darker: #4BB472FF;
    --color-green-06: #52D78399;
    --color-yellow: #FFB400FF;
    --color-yellow-lighten: #ffd980;
    --color-grey: #A6ACB5;
    --color-grey-06: #CACDD3;
    --color-grey-03: #E5E6E9;
    --color-grey-light: #ECECEC;
    --color-black: #212529FF;
    --color-black-lighten: #212529B2;
  }
  
  body {
    background-color: var(--color-white);
    height: 100%;
  }

  .App {
    transition: all 0.5s ease;
    height: 100%;
  }

  ul, li {
    list-style-type: none;
  }

  h1 {
    font-size: 32px;
    font-weight: 800;
    letter-spacing: -0.5px;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -1px;
  }

  h3 {
    font-size: 18px;
    font-weight: 500;
  }

  h4, label {
    font-size: 16px;
    font-weight: 500;
  }

  h5 {
    font-size: 16px;
    letter-spacing: 0.5px;
  }

  h6 {
    font-size: 15px;
    font-weight: 500;
  }

  p, li, textarea {
    font-size: 14px;
  }

  textarea {
    white-space: pre-line;
  }

  a {
    text-decoration: none;
  }

  label {
    font-weight: 700;
  }

  hr {
    border: 0.5px solid var(--color-purple-lighten);
  }

  .shadow {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 15; /** the value is 15 due to the Gantt component who have multiple parts with multiple z-index */
  }

  .slide-to-right {
    opacity: 1 !important;
    transform: translateX(0) !important;
  }

  .flex {
    display: flex;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .flex-col {
    display: flex;
    flex-direction: column;
  }

  .wrap {
    flex-wrap: wrap;
  }

  .jtc-center {
    justify-content: center;
  }

  .jtc-end {
    justify-content: end;
  }

  .row-reverse {
    flex-direction: row-reverse;
  }

  .jtc-spc-btw {
    justify-content: space-between;
  }

  .ai-center {
    align-items: center;
  }

  .align-slf-ctr {
    align-self: center;
  }

  .gap-05 {
    gap: 0.5em;
  }

  .gap-1 {
    gap: 1em;
  }

  .user-selected {
    background-color: var(--color-purple-lighten) !important;
  }

  .selected-grey {
    background-color: var(--color-grey-03) !important;
  }

  .selected-borders-purple{
    border: solid var(--color-purple) !important; ;
  }

  .tag-selected {
    background-color: var(--color-purple-lighten) !important;

    p {
      color: var(--color-black) !important;
    }
  }

  .selected-purple {
    border: 1px solid var(--color-purple) !important;

    p {
      color: var(--color-purple);
    }
  }

  .green-border-full {
    border: 0.2rem solid var(--color-green);
  }

  .green-border {
    border-right: 0.2rem solid var(--color-green);
  }

  .no-hover {
    pointer-events: none;
  }

  .green-dots {
    background-color: var(--color-green);
  }

  .yellow-dots {
    background-color: var(--color-yellow);
  }

  .red-dots {
    background-color: var(--color-red);
  }

  .purple-dots {
    background-color: var(--color-purple);
  }

  .error-text {
    font-size: 0.9em;
    color: var(--color-red);
    font-weight: 800;
    text-align: center;
  }

  .error-text-with-bg {
      font-size: 0.9em;
      color: var(--color-white);
      background-color: rgba(233,64,91,0.8);
      border-radius: 5px;
      font-weight: 800;
      text-align: center;
  }

  .success-text {
    font-size: 0.9em;
    color: var(--color-red);
    font-weight: 800;
  }

  .txt-align {
    text-align: center;
  }

  .xxl-btn {
    justify-content: space-evenly;
    width: 25em !important;
  }

  .animate-hidden {
    transform: scale(0, 0);
    opacity: 0;
  }

  .slide-to-left {
    transform: translateX(-100%);
  }

  .translateX-0 {
    transform: translateX(0%);
  }

  .w-100 {
    width: 100%;
  }

  .w-80 {
    width: 80%;
  }

  .hidden {
    visibility: hidden;
  }

  .display-none {
    display: none !important;
  }

  .visible {
    visibility: visible;
  }

  .absolute {
    position: absolute;
  }


  .tab-selected{
    background-color: rgba(0, 0, 0, 0.1);
  }
  //FONT_WEIGHT
  .fw-700 {
    font-weight: 700;
  }

  //INPUT
  input[type="date"] {
    border-radius: 15px;
    padding: 0.5em;
    border-width: 0.5px;
    border-style: solid;
    border-color: rgba(166, 172, 181, 1);
  }


  // FOR GANTT TOOLTIP
  .e-tooltip-wrap {
    border-radius: 4px;
    opacity: 1;
  }

  .e-tooltip-wrap.e-popup {
    background-color: var(--color-purple);
    border: 1px solid var(--color-purple);
  }
  

  // FOR GANTT CELL 
  .e-treecell {
    font-weight: 700;
  }
  .e-custom-event-marker{
    color: red !important;
  }

  ///KEYFRAME
  @keyframes popin {
    0% {
      opacity: 0;
      transform: scale(0, 0);
    }
    100% {
      opacity: 1;
      transform: scale(1, 1);
    }
  }

  // ENJOY_NEWS

  .enjoy-block-title{
    margin: 1rem 0;
    font-size: 26px;
    //font-weight: bolder;
    //text-transform: uppercase;
    //color: white;
    //-webkit-text-stroke: 1.5px black;
    //-webkit-text-fill-color: transparent;
    //font-family: 'Archivo Black', sans-serif;
    text-align: center;
    
    @media print{
      margin: 0.6rem 0;  
      font-size: 20px;
    }
  }

  // EnjoyCoach

  .question-selected{
    background: white;
    color: var(--color-purple) ;
    border: 2px solid var(--color-purple);
  }

`


export default GlobalStyles